<template>
    <div>
        <el-dialog
            title="编号管理"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="600px">
            <div class="formContent">
                <el-form ref="form" :model="form" label-position="left" label-width="120px">
                    <el-form-item label="凭证号" prop="voucherNumber">
                        <el-input placeholder="请输入内容" v-model="form.voucherNumber"></el-input>
                    </el-form-item>
                    <el-form-item label="请款单号" prop="payRollNumber">
                        <el-input placeholder="请输入内容" v-model="form.payRollNumber"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import util from '@/utils/util'
    export default {
        data() {
            return {
                dialogVisible: false,
                id: '',
                idList: [],
                form: {
                    voucherNumber: '',
                    payRollNumber: ''
                },
            };
        },
        watch:{
            dialogVisible (val) {
                if(this.$refs['form'] && !val){
                    this.$refs['form'].resetFields()
                }
            },
        },
        methods:{
            submit () {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        if(!this.form.payRollNumber && !this.form.voucherNumber) {
                            this.$message.error('请至少输入一种编号')
                            return
                        }
                        this.$confirm('是否确认提交？','温馨提示')
                        .then(_=>{
                            let params = {}
                            if(this.form.voucherNumber) {
                                params['voucherNumber'] = this.form.voucherNumber
                            }
                            if(this.form.payRollNumber) {
                                params['payRollNumber'] = this.form.payRollNumber
                            }
                            this.$Axios._post({
                                url: this.$Config.apiUrl.electricSetVoucherNumber,
                                params: { 
                                    ...params,
                                    idList: this.idList,
                                }
                            }).then(res => {
                                this.$message.success('操作成功')
                                this.dialogVisible = false
                                this.$emit('change')
                            })
                        })
                        .catch(_=>{})
                    }
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    .content{
        background: #F2F6FC99;
        border-radius: 4px;
        padding: 10px;
        margin-bottom: 10px;
    }
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
</style>